import * as React from "react";
import Toast from "../../../../helper/Toast";
import {OnFailure, OnSuccess} from "../../../../../store/action/actionHelpers";
import DictionaryItem from "../../../../../model/dictionary/DictionaryItem";
import CreateDictionarySortableItemFormView from "./CreateDictionarySortableItemFormView";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";

interface IComponentProps {
	/**
	 * Title of dictionary
	 */
	title: string
	/**
	 * On successful created item callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Create item action
	 * @param {DictionaryItem} item
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	onCreateItem: (item: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Error handler
	 * @param err
	 * @returns {string | null}
	 */
	errorHandler?: (err: any) => string | null
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

export default class CreateDictionarySortableItemForm extends React.PureComponent<IComponentProps, IState> {
	public static defaultProps: Partial<IComponentProps> = {
		errorHandler: () => null
	};

	constructor(props: IComponentProps) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<CreateDictionarySortableItemFormView title={this.props.title}
												  onSubmit={this.onSubmit}
												  onCancel={this.props.onCancel}
												  isSubmitting={this.state.isSubmitting}/>
		);
	}

	onSubmit(data: DictionaryItem) {
		this.setState({isSubmitting: true}, () => {
			this.props.onCreateItem(
				data,
				() => {
					this.setState({isSubmitting: false}, () => {
						Toast.success(`${this.props.title} has been created.`, `${this.props.title} create`);
						this.props.onSuccess();
					});
				},
				(err) => this.setState({isSubmitting: false},
					() => {
						const title = `${this.props.title} create`;
						const message = this.props.errorHandler(err);
						if (message) {
							Toast.error(message, title)
						}
						else {
							notifyBugsnagAndShowToast(err, title)
						}
					})
			);
		});
	}
}

